<template>
	<div class="modal-wrapper">
		<button id="show-modal" @click.prevent="showModal = true">
			<span
				v-if="picked_material && success === false"
				v-html="material_name(picked_material)"
			>
			</span>
			<span v-else> {{ translations.show_modal }} </span>
		</button>
		<div class="modal-backdrop" v-if="showModal">
			<div class="modal">
				<span class="close-modal" @click="showModal = false"
					><svg
						aria-hidden="true"
						focusable="false"
						data-prefix="fas"
						data-icon="times"
						class="svg-inline--fa fa-times fa-w-11"
						role="img"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 352 512"
					>
						<path
							fill="currentColor"
							d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
						></path></svg
				></span>
				<h4>{{ translations.modal_title }}</h4>
				<p class="type">
					{{ translations.modal_furniture }}<span>{{ product_title }}</span>
				</p>
				<div class="select-group">
					<label for="sort-by">{{ translations.modal_select }}</label>
					<div class="select">
						<div class="select">
							<select id="sort-by" v-model="sortBy">
								<option
									v-for="(item, index) in data"
									:key="index"
									:value="index"
									>{{ index }}</option
								>
							</select>
							<span class="arrow">
								<svg
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 129 129"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									enable-background="new 0 0 129 129"
								>
									<g>
										<path
											d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
										/>
									</g>
								</svg>
							</span>
						</div>
					</div>
				</div>

				<div class="materials">
					<div
						class="item"
						v-for="item in picked_category"
						:key="item.id"
						@click="setMaterial(item)"
						:class="{ picked: picked_material == item }"
					>
						<div class="img-wrapper">
							<img :src="item.image_url" alt="placeholder" />
						</div>
						<p class="name">{{ material_name(item) }}</p>
					</div>
				</div>

				<p class="price">
					{{ translations.regular_price }}
					<transition name="fade" mode="out-in">
						<span :key="material_name(picked_material)">{{
							$formatMoney(material_price * 100)
						}}</span>
					</transition>
				</p>

				<a class="btn-submit" @click.prevent="pickMaterial">{{
					translations.modal_btn
				}}</a>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: {
		product_handle: { required: true },
		product_title: { required: true },
		success: { type: Boolean, required: true }
	},
	data() {
		return {
			showModal: false,
			sortBy: "",
			data: [],
			error: false,
			translations: this.$translations.product,
			picked_material: "",
			favourite: [],
			version: this.$translations.general.version
		};
	},
	computed: {
		picked_category() {
			return this.data[this.sortBy];
		},
		material_price() {
			const price = `price_${this.version}`;
			return this.picked_material[price]
				? this.picked_material[price]
				: "undefined";
		}
	},
	watch: {
		success: function(val) {
			if (val === true) {
				this.picked_material = "";
			}
		}
	},
	methods: {
		material_name(item) {
			return item[`material_${this.version}`];
		},
		async getData() {
			const url = `https://api.klassik.signifly.io/v1/client/products/${this.product_handle}/material-groups`;

			await axios
				.get(url)
				.then(data => {
					this.data = data.data.data;
				})
				.catch(function(error) {
					this.error = true;
				});
		},
		setMaterial(item) {
			this.picked_material = item;
		},
		createFavourite() {
			for (const key in this.data) {
				this.data[key].forEach(element => {
					if (element.favorite === true) {
						this.favourite.push(element);
					}
				});
			}
			this.data[`${this.translations.favorite}`] = this.favourite;
		},
		pickMaterial() {
			this.$emit("submitted", this.picked_material);
			this.showModal = false;
		}
	},
	async mounted() {
		await this.getData();
		this.sortBy = Object.keys(this.data)[0];
		await this.createFavourite();
	}
};
</script> 


<style lang="scss" scoped>
#show-modal {
	@include button($white, 12px, 25px);
	background-color: $brown;
	text-transform: uppercase;
	display: inline-block;
	font-size: 12px;
	margin-bottom: 15px;
	border: none;

	&::before {
		@include button-hover($bg: $brown);
	}
}

.modal-backdrop {
	position: fixed;
	z-index: 10;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;

	.modal {
		background-color: $grey;
		max-width: 730px;
		width: 100%;
		max-height: 80%;
		padding: 70px;
		box-shadow: 0 0 6px 2px #31373d59;
		position: relative;
		color: #1f2d3d;
		display: flex;
		flex-direction: column;
		overflow: scroll;

		@include res(tab-l) {
			padding: 35px;
		}

		@include res(tab-p) {
			padding: 20px;
			max-height: 100vh;
		}

		.close-modal {
			position: absolute;
			right: 40px;
			top: 40px;
			width: 18px;
			height: 18px;
			cursor: pointer;
			svg {
				width: 100%;
				height: 100%;
			}

			@include res(tab-p) {
				right: 7%;
				top: 4%;
			}
		}

		h4 {
			font-size: 30px;
			font-weight: 400;
			line-height: 36px;
			margin-bottom: 40px;

			@include res(tab-p) {
				margin-bottom: 20px;
			}
		}

		p,
		label {
			font-size: 18px;
			font-weight: 400;
			line-height: 22px;
			margin-bottom: 10px;
			color: inherit;
			font-family: $font-text;
		}

		.type {
			margin-bottom: 20px;

			span {
				margin-left: 10px;
				font-family: $font-text-heavy;
				font-weight: lighter;
			}

			@include res(tab-p) {
				margin: 8px 0;
			}
		}

		.select-group {
			display: flex;
			flex-direction: column;

			select {
				width: 100% !important;
				border-radius: 3px;
				box-shadow: 1px 1px 3px 0px rgba(105, 114, 122, 0.349);
				border: none;
				background-color: $white;
			}
		}

		.price {
			span {
				margin-left: 10px;
				font-family: $font-text-heavy;
				font-weight: lighter;
				display: inline-block;
			}

			@include res(tab-p) {
				padding: 24px 0;
			}
		}

		.materials {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			overflow: scroll;
			min-height: 100px;

			@include res(tab-p) {
				overflow: scroll;
				align-items: baseline;
			}

			.item {
				padding: 7px;
				background-color: $white;
				margin: 8px 5px;
				text-transform: uppercase;
				border-radius: 3px;
				box-shadow: 1px 1px 3px 0px rgba(105, 114, 122, 0.349);
				cursor: pointer;

				@include res(tab-p) {
					flex-basis: calc(33% - 10px);
				}

				.img-wrapper {
					width: 120px;
					height: 50px;
					margin-bottom: 10px;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					@include res(tab-p) {
						width: 100%;
						height: 39px;
					}
				}

				p {
					font-size: 10px;
					line-height: 12px;
					margin: 0;
				}

				.name {
					font-family: $font-text-heavy;
					font-weight: lighter;
				}

				&.picked {
					box-shadow: 1px 1px 3px 0px #b08a73be;
				}
			}
		}

		.btn-submit {
			margin-top: auto;
		}
	}
}

.select {
	position: relative;
	margin-bottom: 8px;

	select {
		-webkit-appearance: none;
		-webkit-appearance: none;
		-moz-appearance: none;
		background-color: transparent;
		appearance: none;
		outline: none;
		border-radius: 0;
		width: 270px;
		max-width: 100%;
		margin-bottom: 0;
	}

	select::-ms-expand {
		display: none;
	}

	.arrow {
		position: absolute;
		right: 22px;
		top: 50%;
		transform: translateY(-50%);
		width: 15px;
		height: 14px;

		&::v-deep svg {
			width: 15px;
			height: 14px;

			path {
				fill: $dark-grey;
			}
		}
	}
}

.change-enter-active,
.change-leave-active {
	transition: all 100ms ease-in-out;
}

.change-enter,
.change-leave-to {
	opacity: 0;
}
</style>
